import React from 'react';
import BusinessCategorySelector from '../components/Onboarding/BusinessCategorySelector';

const OnboardingPage = () => {
  return <BusinessCategorySelector />;
};

export default OnboardingPage;
